// extracted by mini-css-extract-plugin
export var linkText = "_qp-0";